import { Injectable } from '@angular/core';
import { ExtensionCommunicationService } from '@shared/extension';
import { AbstractUserStore } from './abstract';

@Injectable()
export class UserStore extends AbstractUserStore {
  constructor(protected extensionCommunicationService: ExtensionCommunicationService) {
    super(extensionCommunicationService);
  }
}
